const parseString = <ExpectedOutputType>(value: string): ExpectedOutputType | null => {
    try {
        return JSON.parse(value);
    } catch (e) {
        console.error(e);
        return null;
    }
};

const truncStringWithElepsis = (string: string, visibleCharactersNumber: number): string =>
    `${string.slice(0, visibleCharactersNumber)}...`;

export { parseString, truncStringWithElepsis };
